import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import API from "../../actions";

export default props => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button
                variant="contained"
                color="primary"
                style={{ margin: "0 10px 0 10px" }}
                onClick={() => setOpen(true)}>
                Send til alle
            </Button>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Sikker på du vil sende?</DialogTitle>
                <DialogContent>
                    {props.newsletter ? (
                        <DialogContentText id="alert-dialog-description">
                            Du er ved at sende nyhedsbrevet "{props.name}" til alle klienter der har givet samtykke til
                            at modtage nyhedsbreve.
                        </DialogContentText>
                    ) : (
                        <DialogContentText id="alert-dialog-description">
                            Du er ved at sende opfølgningsbeskeden "{props.name}" til alle klienter klienter tilknyttet
                            behandlingen.
                        </DialogContentText>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        Annuler
                    </Button>
                    <Button
                        onClick={async () => {
                            API.newsletter(props.name, props.description);
                            setOpen(false);
                        }}
                        color="primary"
                        autoFocus>
                        Bekræft
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
